import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import config from "../../Config";
import moment from 'moment';
import axios from "axios";

function Footer(props) {
    const [baseURL] = useState(config.base_url);
    const [companyName, setCompanyName] = useState("MaimaSoft.com");

    const FYear = localStorage.getItem("DefaultFYear");
    const DefaultSessionName = localStorage.getItem("DefaultSessionName");

    useEffect(() => {
        axios({
            method: "post",
            url: config.base_url + "School/GetLoginBranding",
            headers: {
                "Content-Type": "application/json",
            },
            data: {},
        })
            .then(function (response) {
                if (response.data?.status_code === 1 && response.data.companyName) {
                    setCompanyName(response.data.companyName);
                }
            })
            .catch(function () {
                // Keep default powered-by text if branding API is unavailable.
            });
    }, []);

    return (
        <>
            <footer>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-2">
                            &copy; {moment().format("YYYY")} - All Rights Reserved.
                        </div>
                        <div className="col-md-2">
                            {baseURL}
                        </div>
                        <div className="col-md-2">
                            {DefaultSessionName}
                        </div>
                        <div className="col-md-3 text-center">
                            Current working year is <NavLink to="/Accounts/ChangeYear"><strong>{FYear}</strong></NavLink>
                        </div>


                        <div className="col-md-3 text-md-end">
                            Powered by: {companyName}
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
}

export default Footer;
